import { FadeUp, Overline } from "./Reveal";

const PARTNERS = ["Brijesh Lakhani", "Prashant Jethani", "Sanjay Parmar"];

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="bg-white py-20 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-20">
          <FadeUp>
            <div className="relative">
              <div className="overflow-hidden rounded-2xl">
                <img
                  src="/assets/brand/about-spices.jpg"
                  alt="Premium Indian spices and food ingredients offered by RBL EXIM"
                  loading="lazy"
                  className="aspect-[4/3] w-full object-cover transition-transform duration-700 hover:scale-[1.03]"
                />
              </div>
              <div className="absolute -bottom-6 -left-4 flex items-center gap-3 rounded-2xl border border-navy/10 bg-white p-4 shadow-xl shadow-navy/10 md:-left-8">
                <img src="/assets/brand/logo.png" alt="RBL EXIM" className="h-14 w-14 object-contain" />
                <div>
                  <p className="font-display text-sm font-semibold text-navy">RBL EXIM</p>
                  <p className="text-xs text-navy/60">Rajkot, Gujarat, India</p>
                </div>
              </div>
            </div>
          </FadeUp>

          <FadeUp delay={0.1}>
            <Overline>About RBL EXIM</Overline>
            <h2 className="mt-4 font-display text-3xl font-semibold leading-[1.08] tracking-tight text-navy md:text-5xl">
              Your Trusted Partner in Indian Food Export
            </h2>
            <div className="mt-6 space-y-4 text-base leading-relaxed text-navy/70">
              <p>
                RBL EXIM, based in Rajkot, Gujarat, is a trusted exporter of
                high-quality food products, delivering authentic taste and
                consistent quality to global markets.
              </p>
              <p>
                We specialize in sourcing, processing and exporting a wide range
                of premium food products designed to meet international customer
                requirements — spices, pulses, makhana, roasted chana, cooking
                pastes, jams, pickles, mango pulp and other supermarket-ready
                food products.
              </p>
              <p>
                Each product is carefully selected and processed with a focus on
                retaining natural flavour, freshness and nutritional value.
              </p>
            </div>
          </FadeUp>
        </div>

        <FadeUp delay={0.1}>
          <div data-testid="partners-section" className="mt-20 border-t border-navy/10 pt-12 md:mt-24">
            <p className="text-xs font-semibold uppercase tracking-[0.26em] text-gold-dark">
              Founded & Operated By
            </p>
            <div className="mt-8 grid gap-8 sm:grid-cols-3">
              {PARTNERS.map((name, i) => (
                <div key={name} data-testid={`partner-${i}`} className="border-l-2 border-gold pl-5">
                  <p className="font-display text-xl font-semibold tracking-tight text-navy md:text-2xl">
                    {name}
                  </p>
                  <p className="mt-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-navy/50">
                    Partner
                  </p>
                </div>
              ))}
            </div>
          </div>
        </FadeUp>

        <FadeUp delay={0.1}>
          <div data-testid="team-section" className="mt-16 border-t border-navy/10 pt-12">
            <h3 className="font-display text-2xl font-semibold tracking-tight text-navy md:text-3xl">
              Team Behind Our Success
            </h3>
            <div className="mt-8 grid gap-6 sm:grid-cols-2">
              {[
                { name: "Keya Biswas", role: "Head of Sales", initials: "KB" },
                { name: "Hitesh Parmar", role: "Head of Operations", initials: "HP" },
              ].map((member, i) => (
                <div
                  key={member.name}
                  data-testid={`team-member-${i}`}
                  className="flex items-center gap-5 rounded-2xl border border-navy/10 bg-cream p-7 transition-[transform,border-color] duration-300 hover:-translate-y-0.5 hover:border-gold"
                >
                  <span className="flex h-16 w-16 shrink-0 items-center justify-center rounded-full bg-navy font-display text-xl font-semibold tracking-wide text-gold">
                    {member.initials}
                  </span>
                  <div>
                    <p className="font-display text-xl font-semibold tracking-tight text-navy">
                      {member.name}
                    </p>
                    <p className="mt-1 text-xs font-semibold uppercase tracking-[0.18em] text-gold-dark">
                      {member.role}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </FadeUp>
      </div>
    </section>
  );
}
